Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

    Concerns.ReviewHelpers = {
        templateHelpers: {
            pluckReviews: function(prod) {
                //todo: remove the prod.reviews_info? check after we go live, it's only for initial push cache issues
                var reviews = prod.reviews_info ? prod.reviews_info.reviews : [];
                var reviewObj = _.map(reviews, function(review) {
                    review.productImage = prod.image_thumb || prod.image;
                    review.productName = prod.title;
                    return review;
                });

                return reviewObj;
            },
            ensureUniqueReviews: function(review) {
                return _.contains(gon.activeReviewIds, review.id);
            },
            selectReview: function() {
                //get a product attached to this product
                var productList = this.products;

                //for now im gonna make this subset object the "default". no sense adding a bunch of
                //fields we're not even using right now. perhaps this can live in the API in the future.
                var selectedReview = {
                    id: 0,
                    score: 0,
                    title: 'No Review',
                    content: 'No Review',
                    user_name: ''
                };

                //if there's no products, just return a default one (still want to print stuff for ADA purposes)
                if (productList.length) {
                    gon.activeReviewIds = gon.activeReviewIds || [];

                    //extract every tagged product's review, remove anything already active and randomly pick one to show
                    var reviewsList = _.reject(_.flatten(_.map(productList, this.pluckReviews)), this.ensureUniqueReviews);
                    var reviewIndex = Math.floor(Math.random() * reviewsList.length);

                    //we are not certain this has a review since we add the text to ALL photos (regardless of whether
                    //or not we visibly show it, due to ADA)
                    if (reviewsList[reviewIndex]) {
                        selectedReview = reviewsList[reviewIndex];
                    }

                    //we don't want to run out of reviews so every 60 reviews or so we clear the queue and allow repeats
                    if (gon.activeReviewIds.length > 30) {
                        gon.activeReviewIds = [];
                    }

                    gon.activeReviewIds = gon.activeReviewIds.concat(selectedReview.id);
                }

                //set the review for this photo item
                this.selectedReview = selectedReview;
            },
            getReview: function() {
                //we want the same result for all calls to this function per view, so only "select" once and use as
                //a getter for all subsequent calls
                if (_.isFalsy(this.selectedReview)) {
                    this.selectReview();
                }

                return this.selectedReview;
            }
        }
    };
});
